// Default reprint bundle
import '../css/vendor/soundmanager2/inlineplayer.css';
import '../css/pages/default/reprint/cry-out-with-joy/index.css';
import '../css/pages/default/reprint/cry-out-with-joy/main.css';
import '../css/pages/default/reprint/cry-out-with-joy/page.css';
import '../css/pages/default/reprint/lyricpsalter/index.css';
import '../css/pages/default/reprint/lyricpsalter/page.css';

import { runLegacy } from './helpers/load-legacy';
import soundmanagerJs  from '../js/vendor/soundmanager2/soundmanager2.js?legacy';
import inlineplayerJs  from '../js/vendor/soundmanager2/inlineplayer.js?legacy';
import reprintIndexJs  from '../js/pages/default/reprint/index.js?legacy';

runLegacy(
    soundmanagerJs,
    inlineplayerJs,
    reprintIndexJs,
);
